<template>
  <div class="modal fade" id="info-comfirm" role="dialog" @click="$emit('close')">
    <div class="modal-dialog modal-lg" @click.stop>
      <!-- Modal content-->
      <div class="modal-content">
        <div class="modal-header bg-color-info">
          <button type="button" class="close close-btn" data-dismiss="modal" @click="$emit('close')"> &times;</button>
        </div>
        <div class="modal-body">
          <template v-for="(item, index) in data">
            <div v-bind:key="index" v-if="index === 0">
              <p>プラン商品登録可能数</p>
              <div class="table-responsive">
                <table class="table table-bordered">
                  <thead>
                    <tr>
                      <th class="col-sm-10">プラン</th>
                      <th class="col-sm-2">商品数</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td align="center">{{item.memo}}</td>
                      <td align="right">{{item.amount}}</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </template>
          <p>追加商品登録可能数</p>
          <div class="table-responsive">
            <table class="table table-bordered">
              <thead>
                <tr>
                  <th class="col-sm-2">日付</th>
                  <th class="col-sm-8"></th>
                  <th class="col-sm-2">商品数</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(item, index) in data" :key="index">
                  <td v-if="index !== 0" align="center">{{item.date}}</td>
                  <td v-if="index !== 0">{{item.memo}}</td>
                  <td v-if="index !== 0" align="right">{{item.amount}}</td>
                </tr>
              </tbody>
            </table>
          </div>
          <br>
          <div class="table-responsive">
            <table class="table table-bordered">
              <tbody>
                <tr>
                  <td align="center" class="col-sm-10">現在の最大商品登録可能数</td>
                  <td align="right" class="col-sm-2">{{totalAmount}}</td>
                </tr>
              </tbody>
            </table>
          </div>
          <p>※最大商品登録可能数は、プラン商品可能数と追加商品登録可能数の合計となります。</p>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn" data-dismiss="modal" @click="$emit('close')">閉じる</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  components: {
  },

  data () {
    return {
    }
  },

  computed: {
  },

  watch: {
  },

  props: ['data', 'totalAmount'],

  mounted () {
    $('#info-comfirm').modal('show')
  },
  beforeDestroy () {
    this.$emit('close')
    $('.modal-backdrop').remove()
  }
}
</script>



// WEBPACK FOOTER //
// src/components/ListingInfoModal.vue